import { Injectable } from '@angular/core';
import { Subscription, Subscriber, Observable, of, timer } from 'rxjs';
import { LoaderParams } from '../loader-params';
import { concatMap, finalize, share, tap } from 'rxjs/operators';

@Injectable()
export class LoaderService {

  private allLoadersAreSmall = true;
  private nbLoaders = 0;
  private loadingEmitter: Subscriber<LoaderParams>;
  private loadingObservable: Observable<LoaderParams>;
  private loadingTimerSubscription: Subscription;
  private timeout   = 180000;

  constructor() {
    this.loadingObservable = new Observable<LoaderParams>(e => this.loadingEmitter = e).pipe(share());
  }

  getObservable(): Observable<LoaderParams> {
    return this.loadingObservable;
  }

  startLoadAndCloseWhenComplete<T>(observable: Observable<T>, small = true): Observable<T> {
    return of({})
      .pipe(
        tap(() => this.startLoad(small)),
        concatMap(() => observable),
        finalize(() => this.stopLoad()),
      );
  }

  startLoad(small = true) {
    this.increment();

    if (!small) {
      this.allLoadersAreSmall = false;
    }

    if (this.nbLoaders >= 1) {
      this.loadingEmitter.next({ loading: true, small: this.allLoadersAreSmall });
    } else {
      this.loadingTimerSubscription.unsubscribe();
    }

    this.loadingTimerSubscription = timer(this.timeout).subscribe(() => {
      console.warn('Loader timeout, something probably went wrong');
      this.loadingEmitter.next({ loading: false });
    });
  }

  stopLoad() {
    this.decrement();

    if (this.nbLoaders === 0) {
      this.allLoadersAreSmall = true;
      this.loadingEmitter.next({ loading: false });
      this.loadingTimerSubscription.unsubscribe();
    }
  }

  private increment() {
    if (this.nbLoaders < 0) {
      this.nbLoaders = 0;
    }

    this.nbLoaders++;
  }

  private decrement() {
    this.nbLoaders--;

    if (this.nbLoaders < 0) {
      this.nbLoaders = 0;
    }
  }

}
